export default __webpack_public_path__ + "static/media/genom-ready@2x.89fe597e.png";